import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;

export const getFingerprint = async () => {
  try {
    if (!fpPromise) {
      fpPromise = FingerprintJS.load();
    }

    const fp = await fpPromise;
    const result = await fp.get();

    return result.visitorId;
  } catch (error) {
    console.error('Erro ao obter fingerprint:', error);
    return null;
  }
};

export const getFingerprintWithComponents = async () => {
  try {
    if (!fpPromise) {
      fpPromise = FingerprintJS.load();
    }

    const fp = await fpPromise;
    const result = await fp.get();

    return {
      visitorId: result.visitorId,
      components: result.components,
    };
  } catch (error) {
    console.error('Erro ao obter fingerprint:', error);
    return null;
  }
};
